import { FilterCheckbox, useOrderedDepartments } from "@repo/ui";
import { hasItems, isChecked } from "@repo/utils";

import { FilterListContainer } from "./FilterListContainer";
import { type FilterItemsProps } from "./type";

export const DepartmentFilter = ({ actions, filters }: FilterItemsProps) => {
  const departments = useOrderedDepartments();

  return (
    <FilterListContainer id="department-filter">
      {hasItems(departments) &&
        departments.map(([key, value]) => (
          <FilterCheckbox
            key={key}
            id={key}
            value={key}
            label={value}
            checked={isChecked(filters.department, key)}
            onCheckFilter={actions.setDepartment}
          />
        ))}
    </FilterListContainer>
  );
};
